import apiClient from "../axiosClient";
import Filter from "../interfaces/filters";
import { apiCallWrapper, createQueryParam } from "../utils/commonUtils";
import { CoverageListResponse, CoverageUpdateRequest, CoverageDeleteRequest } from "../interfaces/coverage";

export default class CoverageService {
    public static async getCoverageList(filters: Filter[], page: number, pageSize: number) {
        const filterString = createQueryParam(filters, '', -1, '', false, []);
        const response = await apiCallWrapper(() => 
            apiClient.get(`/api/v1/coverage?${filterString}&page=${page}&page_size=${pageSize}`)
        );
        if (response && response.status === 200) {
            // Map API response format to expected interface
            const apiData = response.data;
            return {
                coverage_entries: apiData.data || [],
                count: apiData.total || 0
            } as CoverageListResponse;
        }
    }

    public static async updateCoverageStatus(id: string, request: CoverageUpdateRequest) {
        const response = await apiCallWrapper(() => 
            apiClient.patch(`/api/v1/coverage/${id}`, request)
        );
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async deactivateCoverage(id: string, request: CoverageDeleteRequest) {
        const response = await apiCallWrapper(() => 
            apiClient.delete(`/api/v1/coverage/${id}`, { data: request })
        );
        if (response && response.status === 200) {
            return response.data;
        }
    }
}
